import { Fragment, useEffect } from "react"
import { Stack, Table } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { getAnomaly } from "./dbTableApi"
import { Spinner } from "react-bootstrap"
import { setEditor } from "./dbTablSlice"
import { setAnomalyEditor } from "../anomalyRegistration/anomalySlice"
import { setConfirmedMachine } from "../equipment/equiplmentSlice"
import React from "react"
import { useState } from "react"
import { setPageName } from "../login/loginSlice"

export function DbTable(props) {
    const log = useSelector((state) => state.login);
    const user = useSelector((state) => state.user);
    const table = useSelector((state) => state.table);
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [isMyTasks, setIsMyTasks] = useState(false);
    const handleSearch = (event) => {
        setSearch(event.target.value);
    };



    var validatedType = {
        SECURITY: "Безопасность",
        MINOR: "Незначительное",
        BASIC_CONDITION: "Базовое состояние",
        QUALITY: "Качество",
        POLLUTION: "Загрязнение",
        HARD_TO_REACH: "Труднодоступное"
    }
    var validatedStatus = {
        OPENED: "Открытая",
        CLOSED: "Закрытая",
        OPEN: "Открытая",
        CLOSE: "Закрытая"
    }
    function onOpenEditor(index) {
        if (user.isServiceMaintaince) {
            dispatch(setEditor(index))

        }

    }

    useEffect(() => {
        if (!log.token) {
            return navigate("/login");
        } else {
            dispatch(setPageName("База данных"))
        }
        if (table.editor) {
            dispatch(setAnomalyEditor(table.editor))
            dispatch(setConfirmedMachine({ name: table.editor.equipment_name, id: table.editor.equipment }))
            return navigate("/anomaly-editor")
        }
    })
    if (selectedRow != null) {

    }

    function getRowProperty(index) {
        if (index == selectedRow) {
            return "table-primary"
        }
        return ""
    }
    function onSelectedRowAction(index) {
        if (selectedRow == index) {
            onOpenEditor(index)
        } else {
            setSelectedRow(index)
        }


    }
    function setNameMyTaskButton() {
        if (isMyTasks) {
            return "Мои задачи"
        }
        return "Все задачи"
    }
    function isPhoto(image64) {
        if (image64 == null) {
            return "Нет"
        }
        return "Да"
    }
    //<Image src={row.image64 isPhoto(row.im) } width="100" height="100" display="block"></Image>
    let info = (<Fragment>
        <Spinner animation="border" />
    </Fragment>)
    if (isLoading) {
        let tasks = table.data
        if (isMyTasks) {
            tasks = tasks.filter(row => row.performer_username === user.username)
        }
        const rows = tasks.filter(row => row.username.includes(search)).map((row, index) => (
            <tr key={index} onClick={() => onSelectedRowAction(index)} className={getRowProperty(index)}>
                <td key={index + 1 + "td"}>{index + 1}</td>
                <td key={index + row.username}>{row.username} </td>
                <td key={index + row.equipment_name}>{row.equipment_name}</td>
                <td key={index + row.date_created}>{row.date_created.split('T')[0]}</td>
                <td key={index + row.date_created + row.date_created.split('T')[1].split('.')[0]}>{row.date_created.split('T')[1].split('.')[0]}</td>
                <td key={index + row.type}>{validatedType[row.type]}</td>
                <td key={index + row.description}>
                    <div className="scroll-td text-break">
                        {row.description}
                    </div>
                </td>
                <td key={index + row.performer_username + row.id}>{row.performer_username}</td>
                <td key={index + row.status}>{validatedStatus[row.status]}</td>
                <td key={index + row.image64}>{isPhoto(row.image64)}</td>
                <td key={index + row.video64}>{(row.video64 ? 'Да' : 'Нет')}</td>
            </tr>))
        info = (<Table className="table table-sm table-hover">
            <thead>
                <tr>
                    <th>№</th>
                    <th>Пользователь</th>
                    <th>Оборудование</th>
                    <th>Дата</th>
                    <th>Время начала</th>
                    <th>Тип аномалии</th>
                    <th>Описание</th>
                    <th>Исполнитель</th>
                    <th>Статус</th>
                    <th>Фото</th>
                    <th>Видео</th>

                </tr>
            </thead>
            <tbody className="table-group-divider">
                {rows}
            </tbody>
        </Table>)


    } else {
        setIsLoading(true)
        setTimeout(() => dispatch(getAnomaly(log.token)), 1000);
    }
    return (

        <div className="mx-auto">

            <button type="button" className="btn btn-primary form-control" onClick={() => setIsMyTasks(!isMyTasks)}>{setNameMyTaskButton()}</button>
            <input className="form-control" list="datalistOptions" type="text" placeholder="поиск" onChange={handleSearch} />



            <div className="table-responsive">
                {info}

            </div>
        </div>
    )
}
